// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "prices-2SBFf";
var _4 = "reject_notice-2fJD3";
var _5 = "paper-11HLo";
var _6 = "orderRefundStatus__success-8z9JP";
var _7 = "orderRefundStatus__right-20VJb";
export { _1 as "__esModule", _2 as "mobile", _3 as "prices", _4 as "reject_notice", _5 as "paper", _6 as "orderRefundStatus__success", _7 as "orderRefundStatus__right" }
export default { "__esModule": _1, "mobile": _2, "prices": _3, "reject_notice": _4, "paper": _5, "orderRefundStatus__success": _6, "orderRefundStatus__right": _7 }
